import React, { Component } from 'react';
import {
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon,
  PinterestShareButton,
  LinkedinShareButton,
  FacebookShareButton,
  TwitterShareButton
} from 'react-share';
import './socialSharingBar.css';
export default class socialSharingBar extends Component {
  constructor(props) {
      super(props);
  }
  render() {
    let wrapperClass = '';
    let colorClass = '';
    if(this.props.sticky){
      wrapperClass = ' sticky  white-background shadow'
    }
    if(this.props.greyscale){
      colorClass = " greyscale"
    }
    let url = window.location.href;
    return (
      <div className={"social-sharing-bar-wrapper"+wrapperClass+colorClass}>
        <div className="social-sharing-bar-icon">
          <TwitterShareButton url={url}>
            <TwitterIcon size={32} round={true} />
          </TwitterShareButton>
        </div>
        <div className="social-sharing-bar-icon">
          <FacebookShareButton url={url}>
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
        </div>
        <div className="social-sharing-bar-icon">
          <PinterestShareButton url={url}>
            <PinterestIcon size={32} round={true} />
          </PinterestShareButton>
        </div>
        <div className="social-sharing-bar-icon">
          <LinkedinShareButton url={url}>
            <LinkedinIcon size={32} round={true} />
          </LinkedinShareButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/socialSharingBar/index.js